<template>
  <div class="button">

    <v-slide-x-transition
    mode="out-in">

      <v-progress-circular
        v-if="localState === 1"
        indeterminate
        :width="3"
        key="key1"
        color="white"
      ></v-progress-circular>
    
      <v-icon
      v-else-if="localState === 2"
      color="white"
      key="key2"
      >
      check
      </v-icon>

      <v-icon
      v-else-if="localState === 3"
      color="white"
      key="key3">
      warning
      </v-icon>

      <div v-else>
        {{ text }}
      </div>
    
    </v-slide-x-transition>
  </div>
</template>

<script>
export default {
  props: ['saveState'],
  data () {
    return {
      // 0 - normal state
      // 1 - loading
      // 2 - temp state, success
      // 3 - temp state, error
      localState: 0
    }
  },
  computed: {
    text () {
      if (this.localState === 2) {
        return 'Saved!'
      } else if (this.localState === 3) {
        return 'Error!'
      }
      return 'SAVE'
    }
  },
  watch: {
    localState (nv) {
      if (nv === 2 || nv === 3) {
        setTimeout(() => {
          this.localState = 0
        }, 1500)
      }
      this.$emit('update:saveState', nv)
    },
    saveState (nv) {
      this.localState = nv
    }
  }
}
</script>

<style scoped>
.button {
  border-radius: 2px;
  margin: 6px 8px;
  min-width: 88px;
  height: 36px;
  background: #2196F3;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-weight: 500;
  will-change: box-shadow;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.button:hover {
  background: #42A5F5;
}
</style>
